
/**
 * Focuses the new round's input and provides an option for smooth scrolling
 * This can either just focus (preventScroll) or focus and smoothly scroll
 */
export const attemptFocusAndScroll = (attempt = 1, smoothScroll = false) => {
  console.log(`Focus attempt ${attempt} for new round (smoothScroll: ${smoothScroll})`);
  
  // Find the new round's input and try to focus it
  const activeInput = document.querySelector('.Round:last-child input:not([disabled])');
  if (activeInput instanceof HTMLElement) {
    // Focus without scrolling by using preventScroll option
    activeInput.focus({ preventScroll: true });
    console.log(`Focus attempt ${attempt} succeeded with preventScroll`);
    
    // If smooth scroll is requested, scroll into view after focusing
    if (smoothScroll) {
      setTimeout(() => {
        // Scroll to bottom of page smoothly
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth'
        });
        console.log('Smooth scroll to bottom initiated');
      }, 100); // Small delay to ensure DOM is updated
    }
  } else {
    console.log(`Focus attempt ${attempt} failed, no input found`);
  }
  
  // If this is the first attempt, schedule another attempt after a delay
  if (attempt === 1) {
    setTimeout(() => attemptFocusAndScroll(2, smoothScroll), 300);
  }
};

/**
 * Helper function to smoothly scroll to the bottom of the page
 * This can be called separately from the focus function
 */
export const smoothScrollToBottom = () => {
  console.log('Smooth scroll to bottom initiated');
  window.scrollTo({
    top: document.body.scrollHeight,
    behavior: 'smooth'
  });
};

/**
 * Helper function to smoothly scroll to a specific element
 * Useful for scrolling to game over or other components
 * @param selector CSS selector for the target element
 * @param headerOffset Offset to account for fixed header (default: 80px)
 */
export const smoothScrollToElement = (selector: string, headerOffset = 80) => {
  console.log(`Attempting to scroll to element: ${selector}`);
  const element = document.querySelector(selector);
  if (element) {
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
    console.log(`Scrolled to element: ${selector} with header offset ${headerOffset}px`);
    return true;
  }
  console.log(`Element not found: ${selector}`);
  return false;
};
